import { Alert, styled, Typography } from '@mui/material';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

const StyledAlert = styled(Alert)<{ isBackoffice?: boolean }>(
  ({ isBackoffice }) => ({
    backgroundColor: isBackoffice
      ? NEW_COLORS.GRAYSCALE[700]
      : NEW_COLORS.GRAYSCALE[50],
    borderRadius: '8px',
    color: isBackoffice ? NEW_COLORS.BASE.WHITE : NEW_COLORS.GRAYSCALE[700],
    '& .MuiAlert-icon': {
      color: isBackoffice ? NEW_COLORS.BASE.WHITE : NEW_COLORS.GRAYSCALE[700],
      display: 'flex',
      alignItems: 'center',
    },
  }),
);

const StyledTypography = styled(Typography)<{ isBackoffice?: boolean }>(
  ({ isBackoffice }) => ({
    color: isBackoffice ? NEW_COLORS.BASE.WHITE : NEW_COLORS.GRAYSCALE[700],
    whiteSpace: 'pre-line',
  }),
);

export { StyledAlert, StyledTypography };
